import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { currencyOptions } from '../../staticData/options';
import { currencyStyle } from '../../services/methods';
import { ReactComponent as AddIcon2 } from '../../Icons/add-cart-qtt.svg';
import { ReactComponent as AddIcon } from '../../Icons/add-quantity-icon.svg';
import { ReactComponent as DecreIcon } from '../../Icons/decrease-qtt.svg';
import { buttonVariants } from '../../items/animation';
import { motion } from 'framer-motion';
import 'animate.css';

function ProductCard(props) {
  const [isAnimating, setIsAnimating] = useState(false);
  const { decreStock, mainL, langs, symbol, cart, prod, image, isCart, machineID, twoLine } = props;
  const [quantity, setQuantity] = useState(0);
  const today = new Date();
  const { t } = useTranslation();
  let history = useHistory();
  let result = JSON.parse(localStorage.getItem('products'));
  const theme = JSON.parse(localStorage.getItem('machine'))?.themeColor;

  // console.log('res1ult', result);
  // console.log('prod', prod);

  const ptheProd = result[prod.idx];
  const Fname =
    ptheProd?.name[langs] && ptheProd?.name[langs] !== ''
      ? ptheProd?.name[langs]
      : ptheProd?.name?.en;

  const showModal = (e, details) => {
    Swal.fire({
      title: ' ',
      html: details,
      showCloseButton: true,
      showConfirmButton: false,
    });
    if (!e) var e = window.event;
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
  };

  useEffect(() => {
    if (props.cart.length > 0) {
      const index = props.cart?.findIndex((item) => item.id === ptheProd._id);
      if (index >= 0) {
        setQuantity(props.cart[index].quantity);
      } else {
        setQuantity(0);
      }
    } else {
      setQuantity(0);
    }

    return () => {};
  }, [cart]);

  const addToCart = async (e) => {
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 800);
    const index = props.cart?.findIndex((item) => item.id === ptheProd._id);
    if (ptheProd.current_stock > 0) {
      props.decreStock(ptheProd, ptheProd.current_stock - 1);
      if (
        ptheProd.plan &&
        Date.parse(ptheProd.plan.start) <= today &&
        Date.parse(ptheProd.plan.end) >= today
      ) {
        // setShowp(true);
        // setmyprod(props.prod);
      }
      if (index >= 0) {
        props.alterquantity({ id: ptheProd._id }, cart[index].quantity + 1);
      } else {
        props.add({
          idx: parseInt(ptheProd.idx),
          id: ptheProd._id,
          _id: ptheProd._id,
          key: ptheProd._id,
          limit: ptheProd.limit,
          upc: ptheProd?.upc,
          name: ptheProd.name,
          title: ptheProd.name,
          pop_alert: ptheProd.pop_alert,
          promo: ptheProd.promo,
          price: ptheProd.price,
          discount: ptheProd.discount ? ptheProd.discount : 0,
          percentage: ptheProd.percentage,
          discountedPrice: ptheProd.discountedPrice ?? ptheProd.price,
          image: ptheProd.productPictures[0],
          buyX: ptheProd.buyX ? ptheProd.buyX : 0,
          quantity: 1,
          category: ptheProd.category,
          ingredients: ptheProd.ingredients,
          referTo: ptheProd.referTo,
          prodType: ptheProd.prodType,
          current_stock: ptheProd.current_stock,
          emailCode: ptheProd.emailCode,
          addition: ptheProd.addition,
          tax_type: ptheProd.tax_type,
          bundle_prod: ptheProd.bundle_prod,
        });
      }
    }
  };

  function calculateItemPrice() {
    if (ptheProd.buyX) {
      if (ptheProd.percentage) {
        const details = `<p class="card-product-title"><span style="color: red; font-size: 1.5rem;">${t(
          'Buy'
        ).toUpperCase()} ${ptheProd.buyX} ${t('Or').toUpperCase()} ${t('More').toUpperCase()} ${
          ptheProd.name[langs]
        }, ${t('Get').toUpperCase()} ${ptheProd.amount * 100}% ${t(
          'Off'
        ).toUpperCase()}! </span></p>`;
        return (
          <div>
            <span style={{ margin: 0 }}>
              {currencyStyle(langs, symbol, ptheProd.price.toLocaleString(mainL, currencyOptions))}
            </span>
            &nbsp;&nbsp;{' '}
            <span
              style={{ margin: 0, color: 'red', textDecoration: 'underline dotted' }}
              onClick={(e) => showModal(e, details)}
            >
              {t('Promo')}
            </span>
          </div>
        );
      } else {
        return (
          <div>
            <span style={{ margin: 0 }}>
              {currencyStyle(langs, symbol, ptheProd.price.toLocaleString(mainL, currencyOptions))}
            </span>
            &nbsp;&nbsp;{' '}
            <span style={{ margin: 0, color: 'red', textDecoration: 'underline dotted' }}>
              {t('Promo')}
            </span>
          </div>
        );

        // return <span>${props.price} - <span style={{color: 'red'}}>{t('Promo')}!</span></span>
      }
    } else if (ptheProd.discountedPrice != null && ptheProd.discountedPrice !== ptheProd.price) {
      return (
        <div>
          <span>
            <del>
              {currencyStyle(langs, symbol, ptheProd.price?.toLocaleString(mainL, currencyOptions))}
            </del>

            <span style={{ color: 'red' }}>
              &nbsp;&nbsp;
              {currencyStyle(
                langs,
                symbol,
                ptheProd.discountedPrice?.toLocaleString(mainL, currencyOptions)
              )}
            </span>
          </span>
        </div>
      );
    } else {
      return (
        <div>
          {currencyStyle(langs, symbol, ptheProd.price.toLocaleString(mainL, currencyOptions))}
        </div>
      );
    }
  }

  const selfDecreStock = () => {
    decreStock(ptheProd, ptheProd.current_stock + 1);
    if (quantity === 1) {
      props.remove({ id: ptheProd._id });
    } else if (quantity > 1) {
      const index = props.cart?.findIndex((item) => item.id === ptheProd._id);
      props.alterquantity({ id: ptheProd._id }, props.cart[index].quantity - 1);
    }
  };

  const removeItem = () => {
    decreStock(ptheProd, ptheProd.current_stock + quantity);
    props.remove({ id: ptheProd._id });
  };

  const onClickImg = () => {
    history.push(`/machineUI/product/${machineID}/${ptheProd._id}/${ptheProd.idx}`);
  };

  return (
    <div className="product-card">
      {/* <div className="card-img-div d-flex justify-content-center align-items-center"> */}
      <img className="card-img" src={image} onClick={onClickImg} alt=""></img>
      <div
        className={`${isCart ? 'card-title-white' : 'card-title'} ${
          twoLine ? ' card-twoline' : ''
        }`}
      >
        {Fname}
      </div>
      <div className={isCart ? 'card-price-white' : 'card-price'}>{calculateItemPrice()}</div>
      <div className="home-product-add-remove-div d-flex align-items-center justify-content-center">
        {quantity > 0 &&
          (isCart ? (
            <DecreIcon className="addqtt-svg minus-color" onClick={selfDecreStock} />
          ) : (
            <DecreIcon className="addqtt-svg plus-color" onClick={selfDecreStock} />
          ))}
        {quantity > 0 && (
          <motion.div
            variants={buttonVariants}
            animate={isAnimating ? 'animate' : 'normal'}
            className="home-product-quantity d-flex align-items-center justify-content-center"
            // onClick={() => {
            //   console.log(props.prod);
            // }}
          >
            <span className="home-product-quantity-text">{quantity}</span>
          </motion.div>
        )}

        {result[ptheProd.idx].current_stock > 0 ? (
          isCart ? (
            <AddIcon2
              className={isCart ? 'addqtt-svg minus-color' : 'addqtt-svg'}
              onClick={() => {
                addToCart();
              }}
            />
          ) : theme?.replace_plus === 'true' && quantity === 0 ? (
            <div
              className="view-more-button product-card-add-button"
              onClick={() => {
                addToCart();
              }}
            >
              {t('ADD TO BAG')}
            </div>
          ) : (
            <AddIcon
              className={isCart ? 'addqtt-svg plus-color' : 'addqtt-svg'}
              onClick={() => {
                addToCart();
              }}
            />
          )
        ) : quantity === 0 ? (
          <div className="home-product-soldout d-flex align-items-center justify-content-center">
            <span className="home-product-soldout-text">{t(`SOLD OUT`)}</span>
          </div>
        ) : (
          <div className="addqtt-svg"></div>
        )}
      </div>
      {isCart && theme?.add_delete_button === 'true' && (
        <div className="mt-3">
          <div className="view-more-button product-card-remove-button" onClick={removeItem}>
            {t('REMOVE')}
          </div>
        </div>
      )}
    </div>
  );
}
export default ProductCard;
